import { ColumnTable } from '@octano/global-ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Input } from 'reactstrap';

import { TranslationsKeys } from '../../../../locales/translations';
import { StudyPlanTitulationRow } from '../type';

export function useStudyPlanTitulationColumns({
  onToggle,
  onChangeAmount,
}: {
  onToggle: (studyPlanId: number, hasOverride: boolean) => void;
  onChangeAmount: (studyPlanId: number, amount: string) => void;
}) {
  const { t } = useTranslation(
    TranslationsKeys.CONFIGURATION_FIANANTIAL_OTHERS,
  );

  return useMemo<ColumnTable<StudyPlanTitulationRow>[]>(
    () => [
      {
        columnName: 'name',
        headerText: t('academicLevelTitulationPayment.detail.table.studyPlan'),
        tdClassName: 'text-left',
        thClassName: 'text-left',
        cellFormat: (options) => (
          <span>
            {options.row.name}
            {options.row.modalityName ? ` - ${options.row.modalityName}` : ''}
          </span>
        ),
      },
      {
        columnName: 'hasOverride',
        headerText: t(
          'academicLevelTitulationPayment.detail.table.paymentRequirement',
        ),
        tdClassName: 'text-center',
        thClassName: 'text-center',
        width: '20%',
        cellFormat: (options) => (
          <div className="form-group" style={{ marginTop: '-15px' }}>
            <label className="g-checkbox-input-container">
              <Input
                className="g-checkbox-input"
                type="checkbox"
                checked={options.row.hasOverride}
                disabled={options.row.disabled}
                onChange={() =>
                  onToggle(options.row.studyPlanId, !options.row.hasOverride)
                }
              />
              <span className="checkmark"></span>
            </label>
          </div>
        ),
      },
      {
        columnName: 'paymentAmount',
        headerText: t(
          'academicLevelTitulationPayment.detail.table.paymentAmount',
        ),
        tdClassName: 'text-center',
        thClassName: 'text-center',
        width: '20%',
        cellFormat: (options) => (
          <div className="form-group">
            <Input
              style={{ height: '38px', textAlign: 'center' }}
              type="number"
              min={0}
              className="border-primary"
              disabled={!options.row.hasOverride || options.row.disabled}
              value={options.row.paymentAmount ?? ''}
              onChange={(e) =>
                onChangeAmount(options.row.studyPlanId, e.target.value)
              }
            />
          </div>
        ),
      },
    ],
    [t, onToggle, onChangeAmount],
  );
}

export default useStudyPlanTitulationColumns;
